import Axios from '../Axios';

const customer = {
	create(data) {
		return Axios.post('/clients', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get('/clients?&limit=' + limit + '&page=' + page + search);
	},
	readOne(id) {
		return Axios.get('/clients/' + id);
	},
	update(id, data) {
		return Axios.put('/clients/' + id, data);
	},
	delete(id) {
		return Axios.delete('/clients/' + id);
	},
};

export default customer;
